import styled from 'styled-components'
import { ButtonDeleteInlineUnstyled } from 'Components/Buttons/ButtonDeleteInline/unstyled'

export const ButtonDeleteInline = styled(ButtonDeleteInlineUnstyled)`
  font-size: ${props => props.theme.fontSizes.city.card.link};
  color: ${props => props.theme.colors.regentGray};
  display: block;
  line-height: 16px;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }

  svg {
    fill: ${props => props.theme.colors.regentGray};
    height: 15px;
    width: 14px;
    margin-right: 7px;
  }
`
